var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2 align-right",attrs:{"small":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.buttonTitle()))])
}
var staticRenderFns = []

export { render, staticRenderFns }